module.exports = __webpack_public_path__ + "img/indeximg5.5ec4bd00.png";